import React, { useContext, useState, useEffect } from "react";
import Buttons from "./Buttons";
import {withRouter} from 'react-router-dom'
import MainContext from '../../state/main/mainContext'
import ReactGA from 'react-ga';

const Modal6 = ({  history: {push} }) => {
  const [errorMsg, setErrorMsg] = useState();
  const [seeError, setSeeError] = useState(false);
  const mainContext = useContext(MainContext)
  const {onChange, formData: { email, phone }} = mainContext;

  useEffect(() => {
    ReactGA.pageview(window.location.pathname); 
  }, [])

  const validateEmail = () => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    return false;
  };

  const moveForward = () => {
    if (!validateEmail() && phone === "") {
      setErrorMsg("Please enter a valid email or phone number");
      setSeeError(true);
      console.log("wrong");
      return;
    }
    push('/survey/6')
  };
  const preventSubmit = (e) => {
    e.key === "Enter" && e.preventDefault();
  };
  return (
    <section id="modal-6">
      <div className="container">
        <h2 style={{ visibility: "hidden" }}>How can we reach you?</h2>
        <h2>How can we reach you?</h2>
        <div className="form">
          <input
            type="email"
            name="email"
            value={email}
            placeholder="Email"
            onChange={onChange}
            onKeyPress={preventSubmit}
          />
          <input
            type="text"
            name="phone"
            value={phone}
            placeholder="Phone Number"
            onChange={onChange}
            onKeyPress={preventSubmit}
          />
          {seeError && <p className="errorMsg">{errorMsg}</p>}
        </div>
        <Buttons advance={moveForward} goBack={() => {push('/survey/4')}}  />
      </div>
    </section>
  );
};

export default withRouter(Modal6);
